import React, {useEffect, useState} from 'react';
import Layout from "../Layout";
import {RoleManagement} from "../components/userManagement/role/role";
import {NotificationManagement} from "../components/notification/notification";
import {ProvinceManagement} from "../components/base_information/province/province";
import {CityManagement} from "../components/base_information/city/city";
import {DegreeManagement} from "../components/base_information/degree/degree";
import {StageDegreeManagement} from "../components/base_information/stage_degree/stage_degree";
import {FieldManagement} from "../components/base_information/field/field";
import {BranchManagement} from "../components/base_information/branch/branch";
import {AgentRequestManagement} from "../components/agent/agent_request/agent_request";
import {AgentsManagement} from "../components/agent/agents/agents";
import {ChangePassword} from "../components/profile/change_password";
import {Profile} from "../components/profile/profile";
import {Wallet} from "../components/wallet/wallet";
import {BranchCommissionManagement} from "../components/branch_commission/branch_commission";
import {AgentBranchFeeManagement} from "../components/agent_branch_fee/agent_branch_fee";
import {ScheduleManagement} from "../components/schedule/schedule";
import {BankAccountManagement} from "../components/bank_account/bank_account";
import {ConfirmationCommentManagement} from "../components/confirmation_comment/confirmation_comment";
import {BranchDiscountManagement} from "../components/branch_discount/branch_discount";
import {AgentBranchDiscountManagement} from "../components/agent_branch_discount/agent_branch_discount";
import {ReservationManagement} from "../components/reservation/reservation";
import {AgentReservationManagement} from "../components/reservation/agent_reservation_management";
import {UserReservationManagement} from "../components/reservation/user_reservation_management";
import {PersonServiceManagement} from "../components/service/person_service";
import {AgentServiceManagement} from "../components/service/agent_service";
import {AgentBranchDocumentManagement} from "../components/agent_branch_document/agent_branch_document";
import {BranchDocumentManagement} from "../components/branch_document/branch_document";
import {SchedulesManagement} from "../components/schedule/schedule_management";
import {toast} from "react-toastify";
import {UserReportManagement} from "../components/report_user/user/user";
import {UserRoleReportManagement} from "../components/report_user/user_role/user_role";
import Dashboard from "../components/dashboard/dashboard";
import {UserNotificationReportManagement} from "../components/report_user/user_notification/user_notification";
import {WorkReportManagement} from "../components/report_work/work/work";
import {ConsultationReportManagement} from "../components/report_work/consultation/consultation";
import {ServiceReportManagement} from "../components/report_work/service/service";
import {AdminWithdrawalManagement} from "../components/withdrawal/admin_withdrawal";
import {UserWithdrawalManagement} from "../components/withdrawal/user_withdrawal";
import {ReportWithdrawalManagement} from "../components/report_finance/withdrawal/admin_withdrawal";
import {PaymentReportManagement} from "../components/report_finance/payment/payment";
import {AgentBranchCommissionManagement} from "../components/agent_branch_commission/agent_branch_commission";
import {ConsultationPaymentManagement} from "../components/consultation_payment/consultation_payment";
import {AgentReportManagement} from "../components/report_user/agent/agent";
import {AgentIncomeReportManagement} from "../components/report_finance/agent_income/agent_income";
import {SiteIncomeReportManagement} from "../components/report_finance/site_income/site_income";
import {BackOfficePersonManagement} from "../components/back_office/person/person";
import {BackOfficeAgentRequestManagement} from "../components/back_office/agent_request/agent_request";
import {BackOfficeAgentBranchFeeManagement} from "../components/back_office/agent_branch_fee/agent_branch_fee";
import {VoipCall} from "../components/admin_service/voip_call";
import {SendPaymentLink} from "../components/admin_service/send_payment_link";
import {ChangeWalletBalance} from "../components/admin_service/change_wallet_balance";
import {SendNotification} from "../components/admin_service/send_notification_message";
import {DailyWorkReportManagement} from "../components/report_work/daily_work/daily_work";
// import {DashboardManagement} from "../components/dashboard/dashboard";

const Home = () => {


  const [selectedItem, setSelectedItem] = useState("dashboard")
  const [userInfo, setUserInfo] = useState({});
  const [dataRefresh, setDataRefresh] = useState(Date.now())

  const handleItemClick = (item) => {
    if (localStorage.getItem("defaultItem")) {
      window.location.href = "/loading";
      localStorage.setItem("lastClicked", item)
      setSelectedItem(item);
    } else {
      localStorage.setItem("lastClicked", item)
      setSelectedItem(item);
    }
  };

  useEffect(() => {
    let data = localStorage.getItem('userInfo');
    setUserInfo(data ? JSON.parse(data) : {});

    const item = localStorage.getItem('lastClicked');
    handleItemClick(item);
  }, []);

  useEffect(() => {
    let redirectData = localStorage.getItem('redirect_component');
    let status = localStorage.getItem('status');
    if (redirectData) {
      if (redirectData === "wallet") {
        handleItemClick("wallet");
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        localStorage.removeItem('redirect_component');
        localStorage.removeItem('status');
        setDataRefresh(Date.now())
      }
      if (redirectData === "service") {
        handleItemClick('person_service')
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        localStorage.removeItem('redirect_component');
        localStorage.removeItem('status');
        setDataRefresh(Date.now())
      }
      if (redirectData === "reservation") {
        handleItemClick('reservation')
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        // localStorage.removeItem('redirect_component');
        // localStorage.removeItem('status');
        // setDataRefresh(Date.now())
      }
    }
  }, [dataRefresh]);

  const renderContent = () => {
    switch (selectedItem) {
      case 'roles':
        return (
          <div>
            <RoleManagement/>
          </div>
        );
      case 'notifications':
        return (
          <div>
            <NotificationManagement/>
          </div>
        );
      case 'province':
        return (
          <div>
            <ProvinceManagement/>
          </div>
        );
      case 'city':
        return (
          <div>
            <CityManagement/>
          </div>
        );
      case 'degree':
        return (
          <div>
            <DegreeManagement/>
          </div>
        );
      case 'stage_degree':
        return (
          <div>
            <StageDegreeManagement/>
          </div>
        );
      case 'field':
        return (
          <div>
            <FieldManagement/>
          </div>
        );
      case 'branch':
        return (
          <div>
            <BranchManagement/>
          </div>
        );
      case 'agent_request':
        return (
          <div>
            <AgentRequestManagement changeComponent={setSelectedItem}/>
          </div>
        );
      case 'agents':
        return (
          <div>
            <AgentsManagement/>
          </div>
        );
      case 'change_password':
        return (
          <div>
            <ChangePassword/>
          </div>
        );
      case 'profile':
        return (
          <div>
            <Profile/>
          </div>
        );
      case 'branch_commission':
        return (
          <div>
            <BranchCommissionManagement/>
          </div>
        );
      case 'agent_branch_commission':
        return (
          <div>
            <AgentBranchCommissionManagement/>
          </div>
        );
      case 'branch_discount':
        return (
          <div>
            <BranchDiscountManagement/>
          </div>
        );
      case 'agent_branch_discount':
        return (
          <div>
            <AgentBranchDiscountManagement/>
          </div>
        );
      case 'agent_branch_fee':
        return (
          <div>
            <AgentBranchFeeManagement/>
          </div>
        );
      case 'schedule':
        return (
          <div>
            <ScheduleManagement/>
          </div>
        );
      case 'reservation':
        return (
          <div>
            <ReservationManagement/>
          </div>
        );
      case 'wallet':
        return (
          <div>
            <Wallet/>
          </div>
        );
      case 'bank_account':
        return (
          <div>
            <BankAccountManagement/>
          </div>
        );
      case 'confirmation_comment':
        return (
          <div>
            <ConfirmationCommentManagement/>
          </div>
        );
      case 'agent_reservation':
        return (
          <div>
            <AgentReservationManagement/>
          </div>
        );
      case 'user_reservation':
        return (
          <div>
            <UserReservationManagement/>
          </div>
        );
      case 'person_service':
        return (
          <div>
            <PersonServiceManagement/>
          </div>
        );
      case 'agent_service':
        return (
          <div>
            <AgentServiceManagement/>
          </div>
        );
      case 'agent_branch_document':
        return (
          <div>
            <AgentBranchDocumentManagement/>
          </div>
        );
      case 'branch_document':
        return (
          <div>
            <BranchDocumentManagement/>
          </div>
        );
      case 'schedule_management':
        return (
          <div>
            <SchedulesManagement/>
          </div>
        );
      case 'user_report':
        return (
          <div>
            <UserReportManagement/>
          </div>
        );
      case 'user_role_report':
        return (
          <div>
            <UserRoleReportManagement/>
          </div>
        );
      case 'user_notification_report':
        return (
          <div>
            <UserNotificationReportManagement/>
          </div>
        );
      case 'agent_report':
        return (
          <div>
            <AgentReportManagement/>
          </div>
        );
      case 'work_report':
        return (
          <div>
            <WorkReportManagement/>
          </div>
        );
      case 'daily_work_report':
        return (
          <div>
            <DailyWorkReportManagement/>
          </div>
        );
      case 'consultation_report':
        return (
          <div>
            <ConsultationReportManagement/>
          </div>
        );
      case 'service_report':
        return (
          <div>
            <ServiceReportManagement/>
          </div>
        );
      case 'person_withdrawal':
        return (
          <div>
            <UserWithdrawalManagement/>
          </div>
        );
      case 'new_withdrawal':
        return (
          <div>
            <AdminWithdrawalManagement/>
          </div>
        );
      case 'report_withdrawal':
        return (
          <div>
            <ReportWithdrawalManagement/>
          </div>
        );
      case 'report_payment':
        return (
          <div>
            <PaymentReportManagement/>
          </div>
        );
      case 'agent_income':
        return (
          <div>
            <AgentIncomeReportManagement/>
          </div>
        );
      case 'site_income':
        return (
          <div>
            <SiteIncomeReportManagement/>
          </div>
        );
      case 'consultation_payment':
        return (
          <div>
            <ConsultationPaymentManagement/>
          </div>
        );
      case 'dashboard':
        return (
          <div>
            <Dashboard/>
          </div>
        );
      case 'modify_person':
        return (
          <div>
            <BackOfficePersonManagement/>
          </div>
        );
      case 'add_agent':
        return (
          <div>
            <BackOfficeAgentRequestManagement/>
          </div>
        );
      case 'modify_agent_branch_fee':
        return (
          <div>
            <BackOfficeAgentBranchFeeManagement/>
          </div>
        );
      case 'voip_call':
        return (
          <div>
            <VoipCall/>
          </div>
        );
      case 'send_payment_link':
        return (
          <div>
            <SendPaymentLink/>
          </div>
        );
      case 'change_wallet_balance':
        return (
          <div>
            <ChangeWalletBalance/>
          </div>
        );
      case 'send_notification':
        return (
          <div>
            <SendNotification/>
          </div>
        );
      case 'navigate_voip':
        return (
          window.open("https://192.168.2.9", "_blank", "noreferrer")
        );
      default:
        return <Dashboard/>;
    }
  };

  if (localStorage.getItem('userInfo')) {
    return <Layout sidebarClickHandler={handleItemClick} userInfo={userInfo}>
      {renderContent()}
    </Layout>
  } else {
    window.location.href = "/login";
  }

};

export default Home;